export const lbd = [
  {
    day: 'Mon',
    count: 145,
  },
  {
    day: 'Tue',
    count: 141,
  },
  {
    day: 'Wed',
    count: 178,
  },
  {
    day: 'Thu',
    count: 200,
  },
  {
    day: 'Fri',
    count: 174,
  },
  {
    day: 'Sat',
    count: 151,
  },
  {
    day: 'Sun',
    count: 163,
  },
]
